<div class="emptyContainer">
  <div class="innerEmptyContainer">
    <span class="emptyContainerText" i18n="ReportWidgetComponentEmpty|Report Widget Component Empty Label@@dynamicReport_emptyWidget"
      >Sem dados para apresentar</span
    >
  </div>
</div>
